import { useEffect } from "react";

const ClearDataOnLoad = ({ children }) => {
  useEffect(() => {
    // Clear Local Storage
    localStorage.clear();

    // Clear Session Storage
    sessionStorage.clear();

    // Clear Cookies
    const cookies = document.cookie.split("; ");
    cookies.forEach((cookie) => {
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`;
    });

    console.log("Local storage, session storage, and cookies cleared on load");
  }, []);

  return <>{children}</>;
};

export default ClearDataOnLoad;
